import { Utilities } from "../classes/Utilities";
var AddToCart = /** @class */ (function () {
    function AddToCart() {
        this.selectors = {
            container: '[data-add-to-cart]',
            option: '[data-add-to-cart-option]',
            variants: '[data-add-to-cart-variants]',
            variantId: '[data-add-to-cart-variant-id]',
            addToCartBtn: '[data-add-to-cart-btn]',
            productPrice: '[data-product-price]'
        };
        this.nodeList = {
            containers: document.querySelectorAll(this.selectors.container)
        };
    }
    AddToCart.prototype.init = function (modules) {
        var _this = this;
        this.modules = modules;
        this.nodeList.containers.forEach(function (container) {
            var variants = _this.getVariants(container);
            var options = container.querySelectorAll(_this.selectors.option);
            for (var _i = 0, _a = Array.from(options); _i < _a.length; _i++) {
                var option = _a[_i];
                option.addEventListener('change', _this.handleOptionChange.bind(_this, container, variants, options));
            }
            ;
        });
    };
    AddToCart.prototype.handleOptionChange = function (container, variants, options) {
        var variantId = container.querySelector(this.selectors.variantId);
        var selectedOptions = this.getSelectedOptions(options);
        var variant = this.getCurrentVariant(variants, selectedOptions);
        this.updatePrice(variant.price);
        this.updateAddToCartBtn(variant.available, container);
        this.updateGallery(variant);
        variantId.value = variant.id;
    };
    AddToCart.prototype.updateGallery = function (variant) {
        var _this = this;
        this.modules.productGallery.nodeList.containers.forEach(function (container) {
            var items = container.querySelectorAll(_this.modules.productGallery.selectors.item);
            var selectedItem = Array.from(items).find(function (item) { return item.dataset.variantId === variant.id.toString(); });
            if (selectedItem) {
                var featuredImg = selectedItem.querySelector('img');
                _this.modules.productGallery.updateFeaturedImg(featuredImg, container);
            }
        });
    };
    AddToCart.prototype.updateAddToCartBtn = function (enabled, container) {
        var addToCartBtn = container.querySelector(this.selectors.addToCartBtn);
        var addToCartBtnSpan = container.querySelector(this.selectors.addToCartBtn).querySelector('span').nextSibling;
        var addToCartBtnInner = container.querySelector(this.selectors.addToCartBtn).querySelector('span.addToCartBtn');
        if (!enabled) {
            addToCartBtn.classList.add('btn-disabled');
            addToCartBtn.classList.remove('bg-customCheckoutGold');
            addToCartBtnSpan.classList.remove('js-go-cart-add-to-cart');
            addToCartBtn.disabled = true;
            addToCartBtnInner.innerText = 'OUT OF STOCK';
        }
        else {
            addToCartBtn.classList.remove('btn-disabled');
            addToCartBtn.classList.add('bg-customCheckoutGold');
            addToCartBtnSpan.classList.add('js-go-cart-add-to-cart');
            addToCartBtn.disabled = false;
            addToCartBtnInner.innerText = 'ADD TO BAG';
        }
    };
    AddToCart.prototype.updatePrice = function (price) {
        var productPrice = document.querySelector(this.selectors.productPrice);
        var formatPrice = Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active
        }).format(price / 100);
        productPrice.innerHTML = formatPrice;
    };
    AddToCart.prototype.getCurrentVariant = function (variants, selectedOptions) {
        return variants.find(function (variant) { return Utilities.Array.equals(variant.options, selectedOptions); });
    };
    AddToCart.prototype.getSelectedOptions = function (options) {
        return Array.from(options).map(function (option) { return option.value; });
    };
    AddToCart.prototype.getVariants = function (container) {
        var variants = container.querySelector(this.selectors.variants);
        return JSON.parse(variants.value);
    };
    return AddToCart;
}());
export { AddToCart };
;
